var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-box"},[(_vm.distributionAge || _vm.distributionAgeDefault)?_c('div',{attrs:{"id":"flowLine"}}):_vm._e(),_c('el-empty',{directives:[{name:"show",rawName:"v-show",value:(!_vm.distributionAge && !_vm.distributionAgeDefault),expression:"!distributionAge && !distributionAgeDefault"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }